import React, { useEffect, useState } from "react";
import { Container, Card, Row, Col, CardBody, CardHeader } from "reactstrap";
import { UserContext } from "../index";
import { List, Table } from "antd";
import { Link } from "react-router-dom";
import { Firestore, Auth, Storage } from "../config/firebase";
import Navigation from "../components/Navigation";

export default function Account() {
  const user = Auth.currentUser;
  const [upvotes, setData] = useState([]);
  const [collections, setCollect] = useState([]);
  const [upvoteposts, setPost] = useState([]);
  const [colectionpost, setCollectpost] = useState([]);

  const [upvoteShow, setupvoteShow] = useState(true);
  const [collectionShow, setcollectionShow] = useState(false);

  useEffect(() => {
    var docRef = Firestore.collection("users").doc(user.uid);

    docRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          if (doc.data().upvotedPosts) {
            setData(doc.data().upvotedPosts);
          }

          if (doc.data().collections) {
            setCollect(doc.data().collections);
          }
          doc.data().upvotedPosts.forEach(res =>
            Firestore.collection("allProducts")
              .doc(res)
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  console.log(doc.data());
                  setPost(oldpost => [...oldpost, doc.data()]);
                }
              })
              .catch(function(error) {
                console.log("Error getting documents: ", error);
              })
          );

          doc.data().collections.forEach(res =>
            Firestore.collection("allProducts")
              .doc(res)
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  console.log(doc.data());
                  setCollectpost(oldpost => [...oldpost, doc.data()]);
                }
              })
              .catch(function(error) {
                console.log("Error getting documents: ", error);
              })
          );
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  }, []);

  async function upvoteClick() {
    setcollectionShow(false);
    setupvoteShow(true);
  }

  async function collectionClick() {
    setcollectionShow(true);
    setupvoteShow(false);
  }

  const columns = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title"
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type"
    },
    {
      title: "Highlight",
      dataIndex: "Highlight",
      key: "Highlight"
    },

    {
      title: "Focus Area",
      dataIndex: "Focus_Area",
      key: "Focus_Area"
    }
  ];

  return (
    <UserContext.Consumer>
      {value => (
        <>
          <Navigation />
          <Container className="pt-5">
            <Card>
              <CardBody>
                <Row>
                  <Col md={3} lg={3} sm={12}>
                    <div
                      style={{
                        background: `url(${value.photoURL ||
                          "https://res.cloudinary.com/dqcsk8rsc/image/upload/v1577268053/avatar-1-bitmoji_upgwhc.png"})  no-repeat center center`,
                        backgroundSize: "cover", 
                        height: "200px",
                        width: "200px"
                      }}
                      className="profile_pic"
                    ></div>
                  </Col>

                  <Col className="pt-5 mText" md={9} lg={9} sm={12}>
                    <h2 className="text-capitalize mb-0">{value.displayName}</h2>
                    <h5 className="text-muted mt-0">{value.email}</h5>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Row className="mt-4">
              <Col md={3} lg={3} sm={12}>
                <Card>
                  <CardBody>
                    <List>
                      <List.Item>
                        <Link onClick={collectionClick}>
                          {collections.length} Collections
                        </Link>
                      </List.Item>

                      <List.Item>
                        <Link onClick={upvoteClick}>
                          {upvotes.length} Upvotes
                        </Link>
                      </List.Item>
                    </List>
                  </CardBody>
                </Card>
              </Col>

              <Col md={9} lg={9} sm={12}>
                {upvoteShow && (
                  <Card>
                    <CardHeader>All Upvotes</CardHeader>
                    <CardBody>
                      <List>
                        <Table columns={columns} dataSource={upvoteposts} />
                      </List>
                    </CardBody>
                  </Card>
                )}

                {collectionShow && (
                  <Card>
                    <CardHeader>All Collections</CardHeader>
                    <CardBody>
                      <List>
                        <Table columns={columns} dataSource={colectionpost} />
                      </List>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>
          </Container>
        </>
      )}
    </UserContext.Consumer>
  );
}
